// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

import style from './WishListBox.scss';

import type { WishList, WishListItem } from '../../../../entities';

type Props = {
  wishList: WishList;
  topWrapStyle?: string;
  index: number;
};

const backgroundColors = [
  style.lightBlue,
  style.lightGreen,
  style.lightYellow,
  style.lightRed,
];

export default class WishListBox extends Component<Props> {
  render() {
    const { wishList } = this.props;
    const { topWrapStyle, index } = this.props;

    const bgColor = backgroundColors[index % backgroundColors.length];
    return (
      <Link className={style.wishListLinkWrap}
            to={`/wish-list/${wishList.user.id}/${wishList.slug}`}>
        <article className={style.wishListBoxWrap}>
          <section className={classNames(style.topWrap, bgColor, topWrapStyle)}>
            <section className={style.content}>
              <div className={style.wishListImageWrap}>
                <img src={wishList.image}
                     alt="image"/>
              </div>
              <p>{wishList.name}</p>
            </section>
          </section>
          <section className={style.bottomWrap}>
            <Fragment>
              {!!wishList.items && wishList.items.slice(0, 6).map((item: WishListItem, index: number) =>
                <div key={index}
                     className={style.imageWrap}><img src={item.image} alt="image"/></div>)}
            </Fragment>
          </section>
        </article>
      </Link>
    );
  }
}

WishListBox.propTypes = {
  wishList: PropTypes.object.isRequired,
  topWrapStyle: PropTypes.string,
  index: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/wish-list-catalog/components/WishListBox/WishListBox.jsx